export const actionType = {
  sensor: 'sensor',
  binarySensor: 'binary_sensor',
  climate: 'climate',
  automation: 'automation',
  light: 'light',
  fan: 'fan',
  alarm: 'alarm_control_panel',
  lock: 'lock',
  inputBoolean: 'input_boolean',
  inputNumber: 'input_number',
  inputDateTime: 'input_datetime',
  inputText: 'input_text',
  script: 'script',
  group: 'group'
};

export const roomsNames = {
  bedroomA: 'bedroom_a',
  livingSpaceA: 'livingspace_a',
  hallwayA: 'hallway_a',

  bathroomA: 'bathroom_a',
  kitchenA: 'kitchen_a',
};

export const actionId = {
  climate: 'climate_entities',
  // per room
  // climate
  wakeTemp: '_wake_temp',
  wakeTime: '_wake_time',
  sleepTemp: '_sleep_temp',
  sleepTime: '_sleep_time',
  wakeMode: '_wake_mode',
  sleepMode: '_sleep_mode',
  autoSet: '_auto_set',
  ecoMode: '_eco_mode',
  syncMode: '_sync_mode',
  // weekend schedule (VI-275)
  weekendWakeTemp: '_weekend_wake_temp',
  weekendWakeTime: '_weekend_wake_time',
  weekendSleepTemp: '_weekend_sleep_temp',
  weekendSleepTime: '_weekend_sleep_time',
  weekendWakeMode: '_weekend_wake_mode',
  weekendSleepMode: '_weekend_sleep_mode',
  scheduleSplit: '_schedule_split',
  activeSchedule: '_active_schedule',
  // lights
  lights: '_lights',
  allLights: 'all_lights',
  lightsAutoOn: '_lights_auto_on',
  lightsAutoOnTime: '_lights_auto_on_time',
  lightsAutoOff: '_lights_auto_off',
  lightsAutoOffTime: '_lights_auto_off_time',
  nightLight: '_night_light',
  nightLightBrightness: '_night_light_brightness',
  circadianLight: '_lights_circadian',
  lightBrightness: '_lights_brightness',
  lightTemperature: '_lights_temperature',
  lightColor: '_lights_color',

  // bathroom
  showerAlert: 'bathroom_a_shower_alert',
  showerAlertTime: 'bathroom_a_shower_alert_time',
  autoFan: 'bathroom_a_fan_auto_on',

  // common
  increaseTemp: 'climate_increase_temperature', //canIncrease
  decreaseTemp: 'climate_decrease_temperature', //canDecrease
  customLightsColor1: 'custom_light_color_01',
  customLightsColor2: 'custom_light_color_02',
  customLightsColor3: 'custom_light_color_03',
  customLightsColor4: 'custom_light_color_04',
  hrvA: 'hrv_a',
  alarmo: 'alarmo',
  frontDoor: 'front_door',
  imLeavingAlarmOn: 'im_leaving_alarm_on',
  vacationMode: 'vacation_mode',
  petMode: 'pet_mode',
  sanitization: 'sanitization',
  sanitizationRunning: 'sanitization_running',
  enableSanitization: 'enable_sanitization',
  lightBrightnessMin: 'light_brightness_min',
  lightBrightnessMax: 'light_brightness_max',
  mediaPlayer: 'livingspace_media_player_bluetooth_enabled',
  // bedroomAutoSet: 'bedroom_a_auto_set',
  // livingAutoSet: 'livingspace_a_auto_set',
} as const;

// The one lock the app controls: the front door, beside the alarm slider (VI-882).
// Shared by the widget and both homepage allowlists, which must name it alike.
export const FRONT_DOOR_LOCK = `${actionType.lock}.${actionId.frontDoor}`;
// The lock's Z-Wave jam notification, which vOS's jam alerts also watch. A
// Z-Wave lock may report a jam only here, never as the lock's own state.
export const FRONT_DOOR_LOCK_JAMMED = `${actionType.binarySensor}.${actionId.frontDoor}_lock_jammed`;
